import script from "./PubInfoBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PubInfoBar.vue?vue&type=script&setup=true&lang=js"

import "./PubInfoBar.vue?vue&type=style&index=0&id=32c28be6&lang=scss"

const __exports__ = script;

export default __exports__